import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

// Public (x-api-key) call — same auth as candidateChatCall in chatAction.js
function shortLinkCall(code) {
  return axios({
    method: "get",
    url: `${process.env.REACT_APP_AI_API_KEY}short-links/${encodeURIComponent(code)}`,
    headers: {
      "x-api-key": process.env.REACT_APP_CANDIDATE_CHAT_API_KEY || "",
      "Content-Type": "application/json",
    },
  });
}

const ShortLinkRedirect = () => {
  const { code } = useParams();
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    const resolve = async () => {
      try {
        const res = await shortLinkCall(code);
        const data = res?.data?.data ?? res?.data;
        const target =
          typeof data === "string"
            ? data
            : data?.long_url || data?.target_url || data?.original_url || data?.url;
        if (cancelled) return;
        if (target) {
          window.location.replace(target);
        } else {
          setError("This link is invalid or has expired.");
        }
      } catch (_) {
        if (!cancelled) setError("This link is invalid or has expired.");
      }
    };

    resolve();
    return () => {
      cancelled = true;
    };
  }, [code]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#1A1E23",
      }}
    >
      {error ? (
        <p style={{ color: "#fff", fontSize: 16, margin: 0 }}>{error}</p>
      ) : (
        <div className="loading-overlay">
          <div
            className="spinner-border"
            role="status"
            style={{ color: "var(--qualify-accent-color, #f75891)" }}
          >
            <span className="visually-hidden">Redirecting…</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShortLinkRedirect;
